import { StartSubscriptionPaymentRequestDTO } from '../../dtos/StartSubscriptionPaymentRequestDTO';
import { api } from '../api';

export const startSubscriptionPaymentService = async (
  data: StartSubscriptionPaymentRequestDTO,
): Promise<void> => {
  await api.post('/payments/startSubscriptionPayment', data);
};
